module.exports = __webpack_public_path__ + "resources/img/main_banner_gov03.2ebdb56f6216c8274145ebe0f3dc1cb4.png";